import React from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import { FormHelperText } from "@mui/material";

const RichTextEditor = ({
  value,
  onChange,
  onBlur,
  error,
  helperText,
  height = "150px",
  minHeight = "200px",
}) => {
  // Editor configuration
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ align: [] }],
      ["link"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    // "bullet",
    "link",
  ];

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <div style={{ minHeight, borderRadius: "8px" }}>
        <ReactQuill
          theme="snow"
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          modules={modules}
          formats={formats}
          style={{ height, borderRadius: "8px" }}
        />
      </div>
      {error && helperText && (
        <FormHelperText
          error
          sx={{
            marginTop: "8px",
            marginLeft: "14px",
          }}
        >
          {helperText}
        </FormHelperText>
      )}
    </div>
  );
};

// Add global styles for Quill editor
const styles = `
  .ql-container {
    border-bottom-left-radius: 8px !important;
    border-bottom-right-radius: 8px !important;
  }
  
  .ql-toolbar {
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
  }

`;

// Add styles to document head
const styleSheet = document.createElement("style");
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);

export default RichTextEditor;
